import useTheme from 'branding/theme';
const useSectionPadding = ({ padding, paddingHorizontal, paddingVertical, paddingTop, paddingBottom, paddingLeft, paddingRight }) => {
    const { sizing: { section: sectionSizing } } = useTheme();
    return {
        ...(padding && { padding: sectionSizing.padding[padding] }),
        ...(paddingHorizontal && {
            paddingLeft: sectionSizing.padding[paddingHorizontal],
            paddingRight: sectionSizing.padding[paddingHorizontal]
        }),
        ...(paddingVertical && {
            paddingTop: sectionSizing.padding[paddingVertical],
            paddingBottom: sectionSizing.padding[paddingVertical]
        }),
        ...(paddingTop && { paddingTop: sectionSizing.padding[paddingTop] }),
        ...(paddingBottom && { paddingBottom: sectionSizing.padding[paddingBottom] }),
        ...(paddingLeft && { paddingLeft: sectionSizing.padding[paddingLeft] }),
        ...(paddingRight && { paddingRight: sectionSizing.padding[paddingRight] })
    };
};
export default useSectionPadding;
//# sourceMappingURL=index.js.map